import { FC, useEffect, useState } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { TournamentDialogVisibilityState } from '../../../modules/tournament';
import Tournament, { TournamentBoundary } from '../../services/Tournament';
import Dialog from '../Dialog';
import TournamentDialog from '../TournamentDialog';
import { Redirect, withRouter } from 'react-router-dom';

const TournamentScaffold: FC = () => {
  // TODO: Set up typing for redux store
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const { tournamentDialogVisibilityState, tournamentRedirectGameId, tournamentRedirectRoutePrefix } = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (state: any) => state.tournament,
    shallowEqual
  );

  const showTournamentDialog = tournamentDialogVisibilityState === TournamentDialogVisibilityState.SHOW;
  const redirectTournament = tournamentDialogVisibilityState === TournamentDialogVisibilityState.REDIRECT;

  const [activeTournament, setActiveTournament] = useState<TournamentBoundary | boolean>(false);

  useEffect(() => {
    Tournament.getActiveTournament().then((tournament) => {
      if (tournament) {
        setActiveTournament(tournament);
      }
    });
  }, []);

  useEffect(() => {
    // as soon as redirect is triggered we want to hide redirect link
    if (redirectTournament) {
      Tournament.hideTournamentDialog();
    }
  }, [redirectTournament]);

  return (
    <>
      {activeTournament && (
        <Dialog
          isOpen={showTournamentDialog}
          closeCallback={() => {
            Tournament.hideTournamentDialog();
          }}
        >
          <TournamentDialog
            tournament={activeTournament}
            launchTournament={(gameId: number) => {
              Tournament.redirectTournamentGame(gameId);
            }}
          />
        </Dialog>
      )}
      {redirectTournament && (
        <Redirect
          push
          to={{
            pathname: `${tournamentRedirectRoutePrefix}${tournamentRedirectGameId}`,
            state: { from: location.pathname },
          }}
        />
      )}
    </>
  );
};

export default withRouter(TournamentScaffold);
